import { makeStyles } from "@material-ui/core";
import { useReducer } from "react";
import { ClientRegister } from "./Client";
import CustomTabStyle from "../../componentes/tabs/CustomTabStyle";
import CustomTabs from "../../componentes/tabs/CustomTabs";
import CallOutlinedIcon from "@material-ui/icons/CallOutlined";
import MailOutlineIcon from "@material-ui/icons/MailOutlineOutlined";
import HomeOutlinedIcon from "@material-ui/icons/HomeOutlined";
import PrintOutlinedIcon from "@material-ui/icons/PrintOutlined";
import SearchIcon from "@material-ui/icons/Search";
import { useTranslation } from "react-i18next";
import a11yProps from "../../componentes/tabs/a11Props";
import TabPanel from "../../componentes/tabs/TabPanel";
import FormContainer from "../../componentes/form-container/FormContainer";
import { ClientAddress } from "./ClientAddress";
import { ClientEmail } from "./ClientEmail";
import { ClientPhone } from "./ClientPhone";
import { ClientPrint } from "./ClientPrint";

/**
 * Author : Lucas
 * 30/12/2025
*/
const useStyles = makeStyles((theme) => ({
    root: {
        marginRight: 10,
    },
}));

const reducer = (state, data) => {
    return { ...state, ...data }
}

const initialState = {
    id: 0,
    tabValue: 0,
};

const ClientControl = () => {

    const { t } = useTranslation();
    const classes = useStyles();
    const [state, dispatch] = useReducer(reducer, initialState);
    const { id, tabValue } = state
    const handleTabChange = (event, newValue) => dispatch({ tabValue: newValue });

    return (
        <>
            <FormContainer>
                <CustomTabs
                    value={tabValue}
                    onChange={handleTabChange}
                    variant="scrollable"
                    scrollButtons="auto"
                    aria-label="client tab"
                >
                    <CustomTabStyle
                        label={t("client")}
                        {...a11yProps(0)}
                        icon={<SearchIcon fontSize="small" classes={classes} />} />
                    <CustomTabStyle
                        label={t("address")}
                        {...a11yProps(1)}
                        disabled={id === 0}
                        icon={<HomeOutlinedIcon fontSize="small" classes={classes} />} />
                    <CustomTabStyle
                        label={t("email")}
                        {...a11yProps(2)}
                        disabled={id === 0}
                        icon={<MailOutlineIcon fontSize="small" classes={classes} />} />
                    <CustomTabStyle
                        label={t("phone")}
                        {...a11yProps(3)}
                        disabled={id === 0}
                        icon={<CallOutlinedIcon fontSize="small" classes={classes} />} />
                    <CustomTabStyle
                        label={t("printer")}
                        {...a11yProps(4)}
                        disabled={id === 0}
                        icon={<PrintOutlinedIcon fontSize="small" classes={classes} />} />
                </CustomTabs>
                <TabPanel value={tabValue} index={0}>
                    <ClientRegister updateId={dispatch} />
                </TabPanel>
                <TabPanel value={tabValue} index={1}>
                    <ClientAddress idClient={id} />
                </TabPanel>
                <TabPanel value={tabValue} index={2}>
                    <ClientEmail idClient={id} />
                </TabPanel>
                <TabPanel value={tabValue} index={3}>
                    <ClientPhone idClient={id} />
                </TabPanel>
                <TabPanel value={tabValue} index={4}>
                    <ClientPrint idClient={id} />
                </TabPanel>
            </FormContainer>
        </>
    )
}

export default ClientControl;